import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'perfume-bottle',
  size: 24,
  node: [
    ['path', { d: 'M 5 22 H 11.072', key: '1ds6j9' }],
    ['path', { d: 'M15 5 C 23 4 23.328 12.676 20 14.536', key: 'm2x5id' }],
    ['path', { d: 'M15.802 10.308 C 14.776 9.465 14 8.496 14 7', key: 'k2g993' }],
    ['path', { d: 'M2 2h.01', key: 't85c5s' }],
    ['path', { d: 'M2 7h.01', key: '4rb8c5' }],
    ['path', { d: 'M5 4.5h.01', key: '1v53bk' }],
    [
      'path',
      {
        d: 'M8.127 22 A 8 8 0 0 1 4 15 3 3 0 0 1 4.879 12.879C 6.879 10.879 10 10 10 7',
        key: '1wboph',
      },
    ],
    ['circle', { cx: '18', cy: '18', r: '4', key: 'lned0m' }],
    ['rect', { x: '9', y: '2', width: '6', height: '5', rx: '1', key: '1wlw2z' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name PerfumeBottle
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNIDUgMjIgSCAxMS4wNzIiIC8+CiAgPHBhdGggZD0iTTE1IDUgQyAyMyA0IDIzLjMyOCAxMi42NzYgMjAgMTQuNTM2IiAvPgogIDxwYXRoIGQ9Ik0xNS44MDIgMTAuMzA4IEMgMTQuNzc2IDkuNDY1IDE0IDguNDk2IDE0IDciIC8+CiAgPHBhdGggZD0iTTIgMmguMDEiIC8+CiAgPHBhdGggZD0iTTIgN2guMDEiIC8+CiAgPHBhdGggZD0iTTUgNC41aC4wMSIgLz4KICA8cGF0aCBkPSJNOC4xMjcgMjIgQSA4IDggMCAwIDEgNCAxNSAzIDMgMCAwIDEgNC44NzkgMTIuODc5QyA2Ljg3OSAxMC44NzkgMTAgMTAgMTAgNyIgLz4KICA8Y2lyY2xlIGN4PSIxOCIgY3k9IjE4IiByPSI0IiAvPgogIDxyZWN0IHg9IjkiIHk9IjIiIHdpZHRoPSI2IiBoZWlnaHQ9IjUiIHJ4PSIxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/perfume-bottle
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PerfumeBottle = createLucideIcon(__iconData);

export default PerfumeBottle;
